import $ from 'jquery';

import PageLoadHook from '../core/PageLoadHook';
import type { Dimension } from '../core/CoreTypes';

export default class DesktopManager extends PageLoadHook {
  private _$element: JQuery<HTMLElement> | undefined;

  public get $element(): JQuery<HTMLElement> {
    if (!this._$element) {
      this._$element = $('body');
      if (!this._$element) {
        throw new Error('Unable to locate body element!');
      }
    }
    return this._$element;
  }

  public readonly edgeBuffer: number;

  public readonly expandHeight: boolean;

  public readonly expandWidth: boolean;

  private startHeight: number = 0;

  private startWidth: number = 0;

  constructor(
    edgeBuffer: number = 20,
    expandHeight: boolean = true,
    expandWidth: boolean = false,
  ) {
    super();
    this.edgeBuffer = edgeBuffer;
    this.expandHeight = expandHeight;
    this.expandWidth = expandWidth;
  }

  public override onPageLoad() {
    this.startHeight = this.$element.height() || 0;
    this.startWidth = this.$element.width() || 0;

    console.debug('Found and initialized desktop.');
  }

  public checkAndAdjustBounds(maxX: number, maxY: number): Dimension {
    const bounds = {
      width: this.$element.width() || 0,
      height: this.$element.height() || 0
    };
    if (this.expandHeight) {
      const checkHeight: number = maxY + this.edgeBuffer;
      if (bounds.height < checkHeight) {
        this.$element.css('height', `${checkHeight}px`);
        bounds.height = checkHeight;
      }
    }

    if (this.expandWidth) {
      const checkWidth: number = maxX + this.edgeBuffer;
      if (bounds.width < checkWidth) {
        this.$element.css('width', `${checkWidth}px`);
        bounds.width = checkWidth;
      }
    }

    return bounds;
  }
}
